import styled from '@emotion/styled';
import SendIcon from 'ui/images/icons/send.svg';
import MailIcon from 'ui/images/icons/mail.svg';
import { useModal } from 'ui/components/screens/modals/useModal';
import { TextArea } from 'ui/components/elements/TextArea/TextArea';
import { TemplateModal } from 'ui/components/screens/modals/TemplateModal/TemplateModal';

const Wrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    padding-top: 10px;
`;

const InputWrapper = styled.div`
    flex: 1;
    width: calc(100% - 20px);

    textarea {
        width: calc(100% - 20px) !important;
    }
`;

const Icon = styled.button`
    margin-top: 4px;
    padding: 8px 10px;
    background-color: var(--main-color-blue);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease-out;
    &:hover {
        opacity: 0.8;
    }

    img {
        width: 20px;
        height: 20px;
    }
`;

const TemplateWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--lightblue);
    border: 2px solid var(--main-color-blue);
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 900;
    gap: 2px;
    padding: 4px 8px;
    color: var(--main-color-blue);
    transition: opacity 0.2s ease-out;
    &:hover {
        opacity: 0.8;
    }
    img {
        width: 15px;
        pointer-events: none;
    }
`;

export interface MessageInputProps {
    archived: boolean;
    message: string;
    setMessage: (message: string) => void;
    sendMessage: () => void;
    companyType: 'company' | 'buyer' | 'agent' | 'supporter';
    requesting: boolean;
    showTemplate?: boolean;
    disabledText?: string;
}

/**
 * メッセージ入力欄
 */
export const MessageInput: React.FC<MessageInputProps> = (props) => {
    const { openModal, closeModal, createModal } = useModal();
    const handleTemplateClick = () => {
        openModal();
    };
    const handleSelectTemplate = (text: string) => {
        if (props.message.trim()) {
            props.setMessage(props.message + '\n' + text);
        } else {
            props.setMessage(text);
        }
    };
    return (
        <>
            {!props.archived && props.showTemplate && (
                <TemplateWrapper
                    disabled={props.requesting || !!props.disabledText}
                    aria-label="テンプレートを表示"
                    onClick={handleTemplateClick}
                >
                    テンプレート
                    <img src={MailIcon} alt="テンプレート" />
                </TemplateWrapper>
            )}
            <Wrapper>
                <InputWrapper>
                    <TextArea
                        value={props.message}
                        onChange={(e) => props.setMessage(e.target.value)}
                        disabled={props.requesting || !!props.disabledText || props.archived}
                        rows={3}
                        resize="vertical"
                        toggledHeightOnFocus
                        placeholder={props.archived ? 'このチャットはアーカイブされています' : 'メッセージを入力'}
                    />
                </InputWrapper>
                {!props.archived && (
                    <Icon
                        disabled={props.requesting || !!props.disabledText}
                        aria-label="送信"
                        onClick={props.sendMessage}
                    >
                        <img src={SendIcon} alt="送信" />
                    </Icon>
                )}
            </Wrapper>
            {props.companyType !== 'agent' &&
                createModal(
                    <TemplateModal
                        onSelect={handleSelectTemplate}
                        onClose={closeModal}
                        companyType={props.companyType}
                    />,
                    {
                        keyboard: true,
                        maskClosable: true,
                        onClose: closeModal,
                    },
                )}
        </>
    );
};
